/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7787:
/***/ (function() {

class ProoftagContainer extends HTMLElement {
    constructor() {
        super(...arguments);
        this.mediaEl = null;
        this.slotEl = null;
        this.placeholder = null;
        this.mql = null;
        this.breakpoint = '(max-width: 749px)';
        this.onChange = () => {
            this.apply();
        };
    }
    connectedCallback() {
        var _a;
        this.mediaEl = this.querySelector('#prooftag-media');
        this.slotEl = this.querySelector('#prooftag-media-slot');
        this.breakpoint = '(max-width: 749px)';
        if (!this.mediaEl || !this.slotEl)
            return;
        this.placeholder = document.createComment('prooftag-origin');
        (_a = this.mediaEl.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(this.placeholder, this.mediaEl);
        this.mql = window.matchMedia(this.breakpoint);
        if (this.mql.addEventListener) {
            this.mql.addEventListener('change', this.onChange);
        }
        else {
            this.mql.addListener(this.onChange);
        }
        this.apply();
    }
    disconnectedCallback() {
        if (this.mql) {
            if (this.mql.removeEventListener) {
                this.mql.removeEventListener('change', this.onChange);
            }
            else {
                this.mql.removeListener(this.onChange);
            }
        }
    }
    apply() {
        var _a, _b;
        if (!this.mediaEl || !this.slotEl || !this.placeholder || !this.mql)
            return;
        if (this.mql.matches) {
            this.slotEl.after(this.mediaEl);
            this.slotEl.hidden = true;
            this.mediaEl.classList.add('prooftag__media--in-slot');
        }
        else {
            (_a = this.placeholder.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(this.mediaEl, this.placeholder);
            this.mediaEl.classList.remove('prooftag__media--in-slot');
            this.slotEl.hidden = false;
            this.placeholder = document.createComment('prooftag-origin');
            (_b = this.mediaEl.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(this.placeholder, this.mediaEl);
        }
    }
}
if (!customElements.get('prooftag-container')) {
    customElements.define('prooftag-container', ProoftagContainer);
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXTERNAL MODULE: ./src/ts/entrypoint/prooftag/prooftag-container.ts
var prooftag_container = __webpack_require__(7787);
;// CONCATENATED MODULE: ./src/ts/entrypoint/prooftag/prooftag-form.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class ProoftagForm extends HTMLElement {
    constructor() {
        super(...arguments);
        this.form = null;
        this.input = null;
        this.button = null;
        this.apiUrl = null;
        this.rootUrl = '';
        this.shopUrl = null;
        this.onSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!this.form || !this.input || !this.button || !this.apiUrl)
                return;
            const reference = this.input.value.trim();
            if (!reference)
                return;
            const shop_url = this.shopUrl;
            if (!shop_url)
                return;
            this.setLoading(true);
            this.clearError();
            try {
                const params = new URLSearchParams(window.location.search);
                const sessionId = params.get('sessionId');
                const body = {
                    shop_url,
                    "number": reference
                };
                if (sessionId) {
                    body.session_id = sessionId;
                }
                const res = yield fetch(this.apiUrl, {
                    method: 'POST',
                    body: JSON.stringify(body)
                });
                if (!res.ok)
                    throw new Error(`HTTP ${res.status}`);
                const data = yield res.json();
                if (data.status === 'ok' || (data.status === 'redirect' && data.url)) {
                    this.handleSuccess(data, reference);
                }
                else {
                    this.showError(data.reason || 'Une erreur est survenue.');
                }
            }
            catch (err) {
                const msg = err instanceof Error ? err.message : 'Erreur réseau';
                console.error('API Error:', err);
                this.showError(msg);
            }
            finally {
                this.setLoading(false);
            }
        });
    }
    connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="text"]');
        this.button = this.querySelector('button[type="submit"]');
        this.apiUrl = this.dataset.apiUrl || null;
        this.rootUrl = this.dataset.rootUrl || '';
        this.shopUrl = this.dataset.shopUrl || null;
        const params = new URLSearchParams(window.location.search);
        const refParam = params.get('ref');
        const sessionIdParam = params.get('sessionId');
        if (refParam && this.input) {
            this.input.value = refParam;
        }
        if (this.form)
            this.form.addEventListener('submit', this.onSubmit);
        if (refParam && sessionIdParam && this.form) {
            this.form.requestSubmit();
        }
    }
    disconnectedCallback() {
        if (this.form)
            this.form.removeEventListener('submit', this.onSubmit);
    }
    handleSuccess(data, reference) {
        if (!this.input)
            return;
        const storedData = {
            image: data.image,
            reference
        };
        sessionStorage.setItem('prooftag_data', JSON.stringify(storedData));
        const url = data.url
            ? this.appendRefParam(data.url, reference)
            : this.buildRedirectUrl(data, reference);
        if (url)
            window.location.href = url;
    }
    appendRefParam(url, reference) {
        try {
            const parsed = new URL(url);
            parsed.searchParams.set('ref', reference);
            return parsed.toString();
        }
        catch (_a) {
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}ref=${encodeURIComponent(reference)}`;
        }
    }
    buildRedirectUrl(data, reference) {
        if (data.handle && reference) {
            const base = this.rootUrl || '';
            return `${base}/products/${encodeURIComponent(data.handle)}?ref=${encodeURIComponent(reference)}`;
        }
        return null;
    }
    showError(message) {
        if (!this.form || !this.input)
            return;
        let errorDiv = this.form.querySelector('.prooftag-form__error');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'prooftag-form__error';
            errorDiv.setAttribute('role', 'alert');
            this.form.appendChild(errorDiv);
        }
        errorDiv.textContent = this.getTranslatedError(message);
        this.input.classList.add('error');
        setTimeout(() => { var _a; return (_a = this.input) === null || _a === void 0 ? void 0 : _a.classList.remove('error'); }, 500);
    }
    getTranslatedError(message) {
        var _a;
        const errorStrings = (_a = window.theme) === null || _a === void 0 ? void 0 : _a.prooftagErrorStrings;
        let errorMessage;
        switch (message) {
            case 'product_not_found':
                errorMessage = errorStrings.productNotFound;
                break;
            case 'code_not_recognized':
                errorMessage = errorStrings.codeNotRecognized;
                break;
            default:
                errorMessage = errorStrings.other || message;
        }
        return errorMessage ? this.decodeHtmlEntities(errorMessage) : message;
    }
    decodeHtmlEntities(text) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        return doc.documentElement.textContent || text;
    }
    clearError() {
        var _a, _b;
        (_b = (_a = this.form) === null || _a === void 0 ? void 0 : _a.querySelector('.prooftag-form__error')) === null || _b === void 0 ? void 0 : _b.remove();
    }
    setLoading(isLoading) {
        if (!this.button || !this.input)
            return;
        this.button.disabled = isLoading;
        this.input.disabled = isLoading;
        this.button.classList.toggle('loading', isLoading);
        this.button.setAttribute('aria-busy', String(isLoading));
    }
}
if (!customElements.get('prooftag-form')) {
    customElements.define('prooftag-form', ProoftagForm);
}

;// CONCATENATED MODULE: ./src/ts/entrypoint/prooftag/prooftag-result.ts
var prooftag_result_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ProoftagResult extends HTMLElement {
    constructor() {
        super(...arguments);
        this.imageContainer = null;
        this.imageElement = null;
        this.referenceSpan = null;
        this.prooftagText = null;
        this.prooftagTextAlternative = null;
        this.apiUrl = null;
        this.sectionRoot = null;
        this.shopUrl = null;
    }
    connectedCallback() {
        this.imageContainer = this.querySelector('.authenticity-image-container');
        this.imageElement = this.querySelector('.bubble-img');
        this.referenceSpan = this.querySelector('.authenticity-ref__value');
        this.prooftagText = this.querySelector('.prooftag__text--default');
        this.prooftagTextAlternative = this.querySelector('.prooftag__text--alternative');
        this.sectionRoot = this.closest('[data-section-type="prooftag-result"]');
        this.apiUrl = this.dataset.apiUrl || null;
        this.shopUrl = this.dataset.shopUrl || null;
        this.handleVisibility();
        const refFromUrl = this.getRefFromUrl();
        const hasStoredData = !!sessionStorage.getItem('prooftag_data');
        if (hasStoredData) {
            this.populateFromSession();
        }
        else if (refFromUrl && this.apiUrl) {
            this.fetchAndDisplay(refFromUrl).catch((err) => {
                console.warn('[ProoftagResult] API fetch failed:', err);
            });
        }
    }
    handleVisibility() {
        var _a;
        if (!this.sectionRoot)
            return;
        const isThemeEditor = ((_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.designMode) === true;
        const hasRef = this.getRefFromUrl() !== null;
        if (!isThemeEditor && !hasRef) {
            this.sectionRoot.remove();
        }
        else {
            this.scrollToSection();
        }
    }
    populateFromSession() {
        try {
            const raw = sessionStorage.getItem('prooftag_data');
            if (!raw)
                return;
            const data = JSON.parse(raw);
            this.displayData(data);
            sessionStorage.removeItem('prooftag_data');
        }
        catch (e) {
            console.warn('[ProoftagResult] session parse error:', e);
        }
    }
    getRefFromUrl() {
        try {
            const usp = new URLSearchParams(window.location.search);
            const ref = usp.get('ref');
            return ref ? ref.trim() : null;
        }
        catch (_a) {
            return null;
        }
    }
    fetchAndDisplay(reference) {
        return prooftag_result_awaiter(this, void 0, void 0, function* () {
            if (!this.apiUrl)
                return;
            if (!this.shopUrl)
                return;
            const res = yield fetch(this.apiUrl, {
                method: 'POST',
                body: JSON.stringify({
                    "shop_url": this.shopUrl,
                    "number": reference
                })
            });
            if (!res.ok)
                throw new Error(`HTTP ${res.status}`);
            const data = yield res.json();
            if (data.status === 'ok' || data.status === 'redirect') {
                this.displayData({ image: data.image, reference });
                const stored = {
                    image: data.image,
                    reference
                };
                sessionStorage.setItem('prooftag_data', JSON.stringify(stored));
            }
            else {
                console.info('[ProoftagResult] API returned KO:', data.reason);
            }
        });
    }
    displayData(data) {
        if (!this.imageContainer || !this.imageElement || !this.referenceSpan)
            return;
        if (data.image) {
            this.imageElement.src = data.image.startsWith('data:')
                ? data.image
                : `data:image/png;base64,${data.image}`;
            this.imageElement.alt = 'Product tag image';
            this.imageElement.classList.remove('hidden');
            if (this.prooftagText) {
                this.prooftagText.classList.remove('hidden');
            }
        }
        else {
            if (this.prooftagTextAlternative) {
                this.prooftagTextAlternative.classList.remove('hidden');
            }
        }
        if (data.reference) {
            this.referenceSpan.textContent = data.reference;
        }
        this.scrollToSection();
    }
    scrollToSection() {
        const target = this.sectionRoot || this;
        const rect = target.getBoundingClientRect();
        const sectionMiddle = rect.top + window.scrollY + rect.height / 2;
        const viewportMiddle = window.innerHeight / 2;
        const top = sectionMiddle - viewportMiddle;
        window.scrollTo({ top, behavior: 'smooth' });
    }
}
if (!customElements.get('prooftag-result')) {
    customElements.define('prooftag-result', ProoftagResult);
}


;// CONCATENATED MODULE: ./src/ts/entrypoint/prooftag/index.ts




}();
/******/ })()
;